import styled from '@emotion/styled';

// import { Title } from '../../../components/Card/ReviewCard';
// import CompanyLogo from '../../../components/CompanyLogo/CompanyLogo';
import { InternalNavLink } from '../../../components/Link/Link';
import {
  healthSignInDataType,
  healthSignInSchema,
  healthSigninInitialValues,
} from '../../../models/auth/healthSignin/healthSignin.model';
import SwitchAccountButton from '../../../components/Button/SwitchAccountButton';
import Formtainer from '../../../components/Authlayout/Formtainer';
import { configSetting } from '../../../config';
import useHealthSignin from '../../../hooks/auth/useHealthSignin';
import { FormComponent } from '../../../components/Form/FormComponent';
import {
  Checkbox,
  PasswordInputField,
  TextInputField,
} from '../../../components/Form/FormField';
import {
  ACCOUNT,
  FORGOT_PASSWORD,
  HEALTH_SIGNUP,
} from '../../../routes/routeConstants';
import { useNavigate } from 'react-router-dom';
import ValidatingFormSubmitButton from '../../../components/Button/FormSubmitButton';
import { FormikHelpers } from 'formik';

const HealthSignIn = () => {
  // const [activeSegment, setActiveSegment] = useState(0);

  // const onStateChange = (index: number) => {
  //   debugger;
  //   setActiveSegment(index);
  // };

  const navigate = useNavigate();

  const { loading, signinHealth } = useHealthSignin();

  const healthSignInSubmit = (
    values: healthSignInDataType,
    actions: FormikHelpers<healthSignInDataType>
  ) => {
    console.log('Form submitted with values:', values);
    signinHealth({ email: values.email, password: values.password });
    actions.resetForm({ values: healthSigninInitialValues });
  };

  // 2) State + ref to track current & previous selection
  // const [accountType, setAccountType] = useState<string>('Locum');
  // const prevAccountTypeRef = useRef<string>(accountType);

  // 3) Handle dropdown selection
  // const handleAccountSelect = (opt: string) => {
  //   prevAccountTypeRef.current = opt;
  //   setAccountType(opt);
  // };

  return (
    <>
      <Formtainer header="SIGN INTO YOUR ACCOUNT" className="signin">
        <Buttons>
          <SwitchAccountButton
            path={`${configSetting.userDashboardUrl}/account/signin`}
          />
        </Buttons>
        <FormComponent
          initialValues={healthSigninInitialValues}
          schema={healthSignInSchema}
          onSubmit={healthSignInSubmit}
        >
          <TextInputField
            label="Email Address"
            name="email"
            type="email"
            placeholder="Enter your email address"
          />
          <PasswordInputField
            label="Password"
            name="password"
            type="password"
            placeholder="Enter your password"
          />
          <RememberMeAndForgotPassword>
            <Checkbox name="rememberMe" className="terms">
              Remember me
            </Checkbox>
            <p
              style={{ cursor: 'pointer' }}
              onClick={() => {
                navigate(`/${ACCOUNT}/${FORGOT_PASSWORD}`);
              }}
            >
              Forgot Password?
            </p>
          </RememberMeAndForgotPassword>
          <br />
          <ValidatingFormSubmitButton className="fillParent" loading={loading}>
            Login
          </ValidatingFormSubmitButton>
        </FormComponent>
      </Formtainer>
      <P>
        Don't have an account?{' '}
        <InternalNavLink
          to={`/${ACCOUNT}/${HEALTH_SIGNUP}`}
          className="regular"
        >
          Sign Up
        </InternalNavLink>
      </P>
      or
      <P>
        Continue as
        <InternalNavLink to={`/`} className="regular">
          Guest
        </InternalNavLink>
      </P>
      <ForgotPasswordMobile
        style={{ cursor: 'pointer' }}
        onClick={() => {
          navigate(`/${ACCOUNT}/${FORGOT_PASSWORD}`);
        }}
      >
        Forgot Password?
      </ForgotPasswordMobile>
    </>
  );
};

export default HealthSignIn;

const RememberMeAndForgotPassword = styled.div`
  display: flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.palette.blackBlack2};
  font-weight: 500;
  font-size: 18px;
  width: 100%;

  & > p {
    color: ${({ theme }) => theme.palette.mainBlue};

    @media (max-width: 768px) {
      display: none;
    }
  }
`;

const P = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme }) => theme.palette.blackBlack2};
  font-weight: 400;

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const ForgotPasswordMobile = styled(P)`
  color: ${({ theme }) => theme.palette.mainBlue};
  border-top: 1px solid ${({ theme }) => theme.palette.greyGrey2};
  margin-top: 1rem;
  padding-top: 1rem;

  @media (min-width: 768px) {
    display: none;
    color: ${({ theme }) => theme.palette.mainBlue};
  }
`;

const Buttons = styled.div`
  // border: 1px solid red;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 480px) {
  }
`;
